import React from 'react';
import { useRobotSetting } from '../../info';
import {
  RobotSettingsSwitch,
  RobotSettingsSwitchProps,
} from './RobotSettingsSwitch';

// Wrapper for RobotSettingsSwitch which runs a query
export const RobotSoundSettingsSwitch = (props: RobotSettingsSwitchProps) => {
  const { robot, disabled = false, ...rest } = props;
  const {
    query: { data: isSoundEnabled },
  } = useRobotSetting(robot, 'sounds_enabled');
  return (
    <RobotSettingsSwitch
      robot={robot}
      disabled={disabled || !isSoundEnabled}
      {...rest}
    />
  );
};
